import Header from "../components/Header";
import Loader from "../components/Loader";
import Sidebar from "../components/Sidebar";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import { pageRoutes } from "../routes/PageRoutes";

const Customers = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { state } = useLocation();
  const [isToggle, setIsToggle] = useState(false);
  const { isLoading2, getInvoiceData } = useSelector(
    (state) => state?.maintainedReducer,
  );

  const onHandleClick = () => {
    setIsToggle(!isToggle);
  };

  if (isLoading2) {
    return <Loader />;
  }

  return (
    <div className="ct_dashbaord_bg">
      <div className={`ct_dashbaord_main ${isToggle == false && "ct_active"}`}>
        <Sidebar path="customers" />
        <div className="ct_content_right">
          <Header onClick={onHandleClick} />
          <div class="ct_px_23 ct_mt_30 pb-5">
            <div class="">
              {/* content */}
              <div class="d-flex justify-content-end align-items-center ct_flex_wrap_575 gap-md-5 gap-4 ct_mb_32 w-100">
                <div class="search-box ">
                  <div class="input-group position-relative">
                    <input
                      class="form-control ct_input ct_input_ps_40 ct_transparent_input"
                      placeholder="Search service name"
                      type="text"
                      value=""
                    />
                    <i class="fas fa-search ct_show_search"></i>
                  </div>
                </div>
                 
                                   <div className="dropdown ct_w_100_575 d-flex">
                                    <button
                                      style={{ backgroundColor: "#fff" }}
                                      className="btn filter-dropdown flex-grow-1 ct_w_100_575 d-flex align-items-center gap-4 justify-content-between text-nowrap"
                                      type="button"
                                      data-bs-toggle="dropdown"
                                      aria-expanded="false"
                                    >
                                      All Status <i className="fa-solid fa-angle-down"></i>
                                    </button>
                                    <ul className="dropdown-menu ct_custom_dropdown_filter">
                                      <li className="ct_pointer">
                                        <a className="dropdown-item">All</a>
                                      </li>
                                      <li className="ct_pointer">
                                        <a className="dropdown-item">Assigned</a>
                                      </li>
                                      <li className="ct_pointer">
                                        <a className="dropdown-item">Unassigned</a>
                                      </li>
                                    </ul>
                                  </div>
                
                           
                                 
                
              </div>
              <div class="row g-3">
                {/* ══ CARD 1 ══ */}
                {[1, 2, 3, 4]?.map((item) => (
                  <div class="col-12 col-sm-6 col-lg-6 col-xl-3 " >
                    <div class="ct_white_bg ct_border_radius_12 ct_p_20 h-100 ct_pointer" onClick={()=>{
                    navigate(pageRoutes?.CustomerDetail)
                  }}>
                      <a >
                        <div class="text-center">
                          <img
                            src="user_profile.png"
                            class="ct_img_50"
                            alt=""
                          />
                          <h5 class="ct_fs_18 ct_fw_400 text-break ct_text_dark mb-1 mt-3">
                            {" "}
                            Jenny Doe
                          </h5>
                          <p class="ct_fs_14 ct_fw_400 ct_text_para mb-0 text-break">
                            jennydoe@servicehub.com
                          </p>
                        </div>
                        <div class="mt-5">
                          <div class="d-flex justify-content-between align-items-center gap-2">
                            <h5 class="ct_fs_14 ct_text_para ct_fw_400 mb-0">
                              Total Boats
                            </h5>
                            <p class="ct_fs_16 ct_text_dark mb-0">17</p>
                          </div>
                          <hr />
                          <div class="d-flex justify-content-between align-items-center gap-2">
                            <h5 class="ct_fs_14 ct_text_para ct_fw_400 mb-0">
                              {" "}
                              Revenue Generated
                            </h5>
                            <p class="ct_fs_16 ct_text_dark mb-0 text-nowrap">
                              $15.5k
                            </p>
                          </div>
                        </div>
                      </a>
                    </div>
                  </div>
                ))}

                {/* delete modal */}
                <div
                  class="modal fade"
                  id="ct_delete_jobmngmnt_modal_post"
                  tabindex="-1"
                  aria-labelledby="ct_delete_jobmngmnt_postLabel"
                  aria-hidden="true"
                >
                  <div class="modal-dialog modal-dialog-centered">
                    <div class="modal-content ct_border_radius_20">
                      <div class="modal-body">
                        <div class="ct_delete_post_modal p-4">
                          <figure>
                            <figcaption>
                              <div class="d-flex justify-content-between align-items-start">
                                <div class="">
                                  <h4 class="ct_fs_24 ct_fw_600 ct_blue_text mb-2">
                                    Delete Job?
                                  </h4>
                                  <p class="mb-0">
                                    Are you sure you want to delete this job?
                                    This action cannot be undone.
                                  </p>
                                </div>

                                <div data-bs-dismiss="modal">
                                  <i class="fa-solid fa-xmark"></i>
                                </div>
                              </div>
                            </figcaption>
                          </figure>
                          <div class="d-flex justify-content-end border-0 gap-2 ct_modal_footer ct_mt_30">
                            <a
                              data-bs-dismiss="modal"
                              class="ct_border_radius_5 ct_h_40 ct_orange_btn text-center ct_pointer"
                            >
                              Yes, Delete
                            </a>
                            <button
                              type="button"
                              class="ct_orange_transparent_btn ct_h_40"
                              data-bs-dismiss="modal"
                            >
                              Cancel
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/*Edit Job Management modal */}

                <div
                  class="modal fade"
                  id="ct_edit_technician_modal_post"
                  tabindex="{-1}"
                  aria-labelledby="ct_edit_technician_postLabel"
                  aria-hidden="true"
                >
                  <div class="modal-dialog modal-lg modal-dialog-centered">
                    <div class="modal-content ct_border_radius_20">
                      <div class="modal-body">
                        <div class="ct_delete_post_modal p-4">
                          <figure>
                            <figcaption>
                              <div class="d-flex justify-content-between align-items-start">
                                <div class="">
                                  <h4 class="ct_fs_24 ct_fw_600 ct_blue_text mb-2">
                                    Edit Technician/Supplier
                                  </h4>
                                  <p class="mb-0 ct_text_para ct_fs_16">
                                    Edit Technician/Supplier
                                  </p>
                                </div>
                                <div data-bs-dismiss="modal" class="ct_pointer">
                                  <i class="fa-solid fa-xmark"></i>
                                </div>
                              </div>
                            </figcaption>

                            <form class="mt-5">
                              <div class="row">
                                <div class="col-lg-6">
                                  <div class="form-group mb-3">
                                    <label class="form-label">
                                      {" "}
                                      Assign To{" "}
                                    </label>
                                    <select
                                      class="form-control ct_input ct_transparent_input ct_pointer_curser"
                                      id="boatId"
                                    >
                                      <option value="">Technician</option>
                                    </select>
                                  </div>
                                </div>
                                <div class="col-lg-6">
                                  <div class="form-group mb-3">
                                    <label class="form-label">
                                      Select Technician
                                    </label>
                                    <select
                                      class="form-control ct_input ct_transparent_input ct_pointer_curser"
                                      id="boatId"
                                    >
                                      <option value="">Select</option>
                                    </select>
                                  </div>
                                </div>

                                <div class="col-lg-6">
                                  <div class="form-group mb-3">
                                    <label class="form-label">
                                      {" "}
                                      Start Date{" "}
                                    </label>
                                    <input
                                      type="date"
                                      class="form-control ct_input ct_transparent_input"
                                    />
                                  </div>
                                </div>

                                <div class="col-lg-6">
                                  <div class="form-group">
                                    <label class="form-label"> End Date </label>
                                    <input
                                      type="date"
                                      class="form-control ct_input ct_transparent_input"
                                    />
                                  </div>
                                </div>
                              </div>
                            </form>
                          </figure>
                          <div class="d-flex justify-content-end border-0 gap-2 ct_modal_footer ct_mt_30">
                            <a
                              data-bs-dismiss="modal"
                              class="ct_border_radius_5 ct_h_40 ct_orange_transparent_btn px-5 text-center ct_pointer"
                            >
                              Cancel
                            </a>
                            <a
                              data-bs-dismiss="modal"
                              class="ct_border_radius_5 ct_h_40 ct_orange_btn px-5 text-center ct_pointer"
                            >
                              Save Changes
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Customers;
